import BeSimpleAPI from '@/providers/api/';

import { baseActions } from './../base_actions'
import { baseMutations } from './../base_mutations'

const state =
{
    api: new BeSimpleAPI(process.env.VUE_APP_FMMODULE_API_URL),
    'documenten': {
        items: [],
        item: {}
    },
    'triggers': {
        items: [],
        item: {}
    },
    'mltriggers': {
        items: [],
        item: {}
    },    
    'invoicerecognition': {
        items: [],
        item: {}
    }, 
    'invoicerecognition/unvalidated': {
        items: [],
        item: {}
    },
    'triggermeldingen': {
        items: [],
        item: {}
    },       
    'feedback': {
        items: [],
        item: {}
    },
    'aiinvoicedata': {
        items: [],
        item: {}
    }             
}

const getters = {
    //List getters
    documenten: state => state['documenten'].items,
    triggers: state => state['triggers'].items,
    mltriggers: state => state['mltriggers'].items,
    invoicerecognitiondata: state => state['invoicerecognition/unvalidated'].items,
    feedback: state => state['feedback'].items,
    triggermeldingen: state => state['triggermeldingen'].items,
    aiinvoicedata: state => state['aiinvoicedata'].items,

    //Single getters
    document: state => state['documenten'].item,
    trigger: state => state['triggers'].item,
    mltrigger: state => state['mltriggers'].item,
    invoicerecognitionitem: state => state['invoicerecognition/unvalidated'].item,
    feedbackone: state => state['feedback'].item,
    triggermelding: state => state['documenten'].item,
    aiinvoicedataitem: state => state['aiinvoicedata'].item
}

const actions = {
    ...baseActions,
    setPositiveValidation(context, invoicerecognitionitem){
        context.commit('SET_POSITIVE_VALIDATION', invoicerecognitionitem);
    },
    setNegativeValidation(context, invoicerecognitionitem){
        context.commit('SET_NEGATIVE_VALIDATION', invoicerecognitionitem);
    }    
}

const mutations = {
    ...baseMutations,
	SET_POSITIVE_VALIDATION(state, invoicerecognitionitem) {
        invoicerecognitionitem.isCorrect = true
		state['invoicerecognition/unvalidated'].items = state['invoicerecognition/unvalidated'].items.filter(item => item !== invoicerecognitionitem)
	},
	SET_NEGATIVE_VALIDATION(state, invoicerecognitionitem) {
        invoicerecognitionitem.isCorrect = false
		state['invoicerecognition/unvalidated'].items = state['invoicerecognition/unvalidated'].items.filter(item => item !== invoicerecognitionitem)
	}     
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}